export type LabType = "public" | "private";

export const getLabType = (usesPrivateLab: boolean): LabType[] => {
    return usesPrivateLab ? ["private"] : ["public"];
};
